// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface GenderFemaleIconSignature {
  Element: SVGSVGElement;
}

export const GenderFemaleIcon: TOC<GenderFemaleIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.001 2C15.31 2 18.001 4.691 18.001 8C18.001 10.966 15.834 13.431 13.001 13.91V17H16.001V19H13.001V22H11.001V19H8.00101V17H11.001V13.91C8.16801 13.432 6.00101 10.967 6.00101 8C6.00101 4.691 8.69201 2 12.001 2ZM12.001 4C9.79501 4 8.00101 5.795 8.00101 8C8.00101 10.206 9.79501 12 12.001 12C14.207 12 16.001 10.206 16.001 8C16.001 5.795 14.207 4 12.001 4Z"/>
</svg>
</template>;